import React, {Component} from "react";
import {connect} from "react-redux";
import PublicLayout from "../../components/public-layout";
import {resetUserMessage} from "../../data/actions/user";
import Resources from "../../data/services/resources";

class PrivacyPolicyView extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.dispatch(resetUserMessage());
    }

    render() {
        const {translate} = this.props;

        return (
            <PublicLayout menuActiveResource={Resources.AboutPage} {...this.props}>
                <section className="margin-10 bgw btop">
                    <div className="container">
                        <div className="section-title-2 text-left">
                        <h2 className="text-center">{translate("text.privacy_policy")}</h2>
                            <p>{translate("text.privacy_policy1")}</p>
                            <p>{translate("text.privacy_policy2")}</p>
                            <p>{translate("text.privacy_policy3")}</p>
                            <p>{translate("text.privacy_policy4")}</p>
                            <h3>{translate("text.privacy_policy5")}</h3>
                            <p>{translate("text.privacy_policy6")}</p>
                            <p>{translate("text.privacy_policy7")}</p>
                            <p>{translate("text.privacy_policy8")}</p>
                            <p>{translate("text.privacy_policy9")}</p>
                            <p>{translate("text.privacy_policy10")} <b>{translate("text.privacy_policy101")}</b></p>
                            <p>{translate("text.privacy_policy11")}</p>
                            <h3>{translate("text.privacy_policy12")}</h3>
                            <p>{translate("text.privacy_policy13")}</p>
                            <li>{translate("text.privacy_policy14")}</li>
                            <li>{translate("text.privacy_policy15")}</li>
                            <h3>{translate("text.privacy_policy16")}</h3>
                            <p>{translate("text.privacy_policy17")}</p>
                            <h3>{translate("text.privacy_policy18")}</h3>
                            <p>{translate("text.privacy_policy19")}</p>
                            <p>{translate("text.privacy_policy20")}</p>
                            <h3>{translate("text.privacy_policy21")}</h3>
                            <p>{translate("text.privacy_policy22")}</p>
                            <h3>{translate("text.privacy_policy23")}</h3>
                            <p>{translate("text.privacy_policy24")}</p>
                            <h3>{translate("text.privacy_policy25")}</h3>
                            <p>{translate("text.privacy_policy26")}</p>
                            <li>{translate("text.privacy_policy27")}</li>
                            <li>{translate("text.privacy_policy28")}</li>
                            <li>{translate("text.privacy_policy29")}</li>
                            <li>{translate("text.privacy_policy30")}</li>
                            <li>{translate("text.privacy_policy31")}</li>
                            <li>{translate("text.privacy_policy32")}</li>
                            <li>{translate("text.privacy_policy33")}</li>
                            <li>{translate("text.privacy_policy34")}</li>
                            <p>{translate("text.privacy_policy35")}<b>{translate("text.privacy_policy351")}</b>{translate("text.privacy_policy352")}</p>
                            <h3>{translate("text.privacy_policy36")}</h3>
                            <p>{translate("text.privacy_policy37")}</p>
                            <p><b>{translate("text.privacy_policy38")}{translate("text.privacy_policy381")}{translate("text.privacy_policy382")}</b></p>
                            <h3>{translate("text.privacy_policy39")}</h3>
                            <p>{translate("text.privacy_policy40")}</p>
                            <p>{translate("text.privacy_policy41")}</p>
                            <li>{translate("text.privacy_policy42")}</li>
                            <li>{translate("text.privacy_policy43")}</li>
                            <li>{translate("text.privacy_policy44")}</li>
                            <p>{translate("text.privacy_policy45")}</p>
                            <p>{translate("text.privacy_policy46")}</p>
                            <p>{translate("text.privacy_policy47")}</p>
                            <p>{translate("text.privacy_policy48")}</p>
                            <p>{translate("text.privacy_policy49")}</p>
                            <hr/>
                        </div>
                    </div>
                </section>

            </PublicLayout>
        );
    }
}

export default connect(state => state)(PrivacyPolicyView);